/**
 * Il titolo di un widget nella dashboard: quello del catalogo, con il periodo
 * quando dello stesso widget ce ne possono essere piu' copie (es. "Fatturato
 * · mese" e "Fatturato · anno" uno accanto all'altro).
 */

import { CATALOGO } from '../../lib/dashboard/catalogo';
import type { WidgetIstanza } from '../../lib/dashboard/layout';

export function titoloWidget(widget: WidgetIstanza): string {
  const base = CATALOGO[widget.tipo].titolo;
  if (widget.tipo === 'fatturato') {
    return `${base} · ${(widget.impostazioni as { periodo: string }).periodo}`;
  }
  return base;
}
